export default "__VITE_ASSET__Cl$ttnDg__"